import React, { useState } from 'react';
import countries from '../data/countries.json';



const getFlagUrl = (countryCode) =>
  `https://flagcdn.com/16x12/${countryCode?.toLowerCase()}.png`;

const CountrySelect = ({ register,selectedCountry,error,defaultValue="LB"  }) => {


  return (
 <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Country
      </label>
      <div className="relative">
        <select
          {...register("country", { required: "Please select your country" })}
          className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        defaultValue={defaultValue}
        >
          <option value="">Select your country</option>
          {countries.map((country) => (
            <option key={country.countryCode} value={country.countryCode}>
              {country.countryName}
            </option>
          ))}
        </select>
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
          <img
             src={getFlagUrl(selectedCountry)} // optionally set a static default
            alt=""
            className="w-5 h-3 object-cover"
          />
        </div>
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error.message}</p>}
    </div>
  );
};

export default CountrySelect;
